import { createPpRscServerSideHelpers } from '@r-and-a-shared-ui/randa-trpc-server/query-client/server';
import { TEMPLATE_ELEMENT_NAME } from './constants';
import {
  getAllUserRolesFromChampionship,
  PlayerPortalsChampionship,
} from '@r-and-a-shared-ui/common-ui';
import { CURRENT_CHAMPIONSHIP_COLLECTION } from '@r-and-a-shared-ui/utils';

type GetIsProtectedArgs = {
  pageRoles: string[];
  templateRoles: string[];
};

export const resolveAccess = ({
  pageRoles,
  templateRoles,
}: GetIsProtectedArgs) => {
  const effectiveRoles = pageRoles.length > 0 ? pageRoles : templateRoles;
  const isProtected = effectiveRoles.length > 0;

  return { isProtected };
};

export const getTemplateCodename = (page: any) =>
  page?.elements?.[TEMPLATE_ELEMENT_NAME]?.value?.[0];

export const getPageRoles = (page: any) =>
  page.elements?.roles?.value?.map((r: { name: string }) =>
    r.name.toLowerCase(),
  ) ?? [];

export const getTemplateRolesAndPrefetch = async (
  trpc: ReturnType<typeof createPpRscServerSideHelpers>['trpc'],
  templateCodename?: string,
) => {
  if (!templateCodename) {
    return [];
  }

  const template = await trpc.kontent.pageTemplateByCodeName({
    codename: templateCodename,
  });

  await trpc.kontent.pageTemplateByCodeName.prefetch({
    codename: templateCodename,
  });

  return (
    template?.elements?.roles?.value?.map((r: { name: string }) =>
      r.name.toLowerCase(),
    ) ?? []
  );
};

export const resolveChampionshipRedirect = (
  userState: any,
  currentChampionship: PlayerPortalsChampionship | undefined,
  availableChampionships: PlayerPortalsChampionship[] | undefined,
) => {
  if (!availableChampionships?.length) {
    return null;
  }

  const rolesForCurrentChampionship =
    getAllUserRolesFromChampionship(userState, currentChampionship) || [];

  const hasAccessToCurrentChampionship = rolesForCurrentChampionship.length > 0;

  if (hasAccessToCurrentChampionship) {
    return CURRENT_CHAMPIONSHIP_COLLECTION;
  }

  const firstAccessibleChampionship = availableChampionships.find(champ => {
    const roles = getAllUserRolesFromChampionship(userState, champ) || [];
    return roles.length > 0;
  });

  if (!firstAccessibleChampionship?.kontentCollection) {
    return null;
  }

  return firstAccessibleChampionship.kontentCollection;
};
